import * as React from 'react';
import { createRoot } from 'react-dom/client';
import type { CheckboxAnswerType, RenderViewPropsType, RenderViewReturnType, DefaultContinueHandlerType } from '../types';
import { CheckboxGroup } from '../../../React/features/Chat/features/CheckboxGroup';

export const COMPONENT_IDENTIFIER = 'checkbox-group';

export type RenderCheckboxGroupPropsType = RenderViewPropsType<{
  answers: Required<CheckboxAnswerType>[];
  applyHandler: (checkedAnswers: Required<CheckboxAnswerType>[]) => void;
  skipHandler?: () => void;
}>

export const renderCheckboxGroup = async (props: RenderCheckboxGroupPropsType): RenderViewReturnType => {
  const { chatRoot, keyName } = props;

  // レンダーするためのルート要素を作成
  const viewContainer = document.createElement('div');
  const viewRoot = createRoot(viewContainer);

  // コンテナ要素にクラス付与
  viewContainer.classList.add(`chat-${COMPONENT_IDENTIFIER}-container`);
  viewContainer.classList.add(keyName);

  // チャットルートにコンテナ要素をappendする
  chatRoot.appendChild(viewContainer);

  return new Promise((resolve) => {
    const continueHandler = (args: DefaultContinueHandlerType) => resolve({ ...args, viewRootDomReference: viewContainer });

    // appendしたコンテナ要素にJsxをレンダリングする
    viewRoot.render(<CheckboxGroup {...props} continueHandler={continueHandler} />);
  });
};
